import React, { useState, useEffect, useRef } from "react";
import "./Style/StudyRoom.css";
import "./Style/common.css";
import "./Style/header.css";
import Loading from "../../Common/Loading";
import Header from "../../Common/Header";
import Section from "../../Common/Section";
import { useNavigate } from "react-router-dom";
import { decryptPayload } from "../../Common/utils/Decrypt";
import SubHeader from "../../Common/SubHeader";
import {
  clearCachedAssessmentStatuses,
  fetchAssessmentStatus,
} from "../../services/assessmentApi";
import trophy_club_large_500 from "./Image/trophy_club/trophy_club_large_0.png";
import trophy_club_large_750 from "./Image/trophy_club/trophy_club_large_10.png";
import trophy_club_large_1000 from "./Image/trophy_club/trophy_club_large_25.png";
import trophy_club_large_1250 from "./Image/trophy_club/trophy_club_large_50.png";
import trophy_club_large_1500 from "./Image/trophy_club/trophy_club_large_75.png";
import trophy_club_large_2000 from "./Image/trophy_club/trophy_club_large_100.png";
import trophy_club_large_2500 from "./Image/trophy_club/trophy_club_large_150.png";
import trophy_club_large_3000 from "./Image/trophy_club/trophy_club_large_200.png";
import trophy_club_large_3500 from "./Image/trophy_club/trophy_club_large_250.png";
import trophy_club_large_4000 from "./Image/trophy_club/trophy_club_large_300.png";
import trophy_club_large_4500 from "./Image/trophy_club/trophy_club_large_350.png";
import trophy_club_large_5000 from "./Image/trophy_club/trophy_club_large_400.png";
interface Activity {
  dicfilename?: string;
  lessoncode: string;
  unitcode: string;
  chaptercode: string;
  activitytype: string;
  howshifted: string | null;
  completedflag: string | null;
  lastscore: number | null;
  lastdoneon: string | null;
  ChildShortDesc: string;
  FileID?: string;
  LevelNo?: number;
  DicCode?: string;
  type?: string;
  is_current?: boolean;
  lesson_status?: string;
}

interface WlpResponse {
  activities: Activity[];
  recent_lessons: Activity[];
  extra_activities: Activity[];
  done_summary: string;
  completion_percentage: string;
}

const trophyClubMinimums = [0, 10, 25, 50, 75, 100, 150, 200, 250, 300, 350, 400];

const getTrophyClubIndex = (trophyCount: number): number => {
  let clubIndex = 0;

  trophyClubMinimums.forEach((minimum, index) => {
    if (trophyCount >= minimum) {
      clubIndex = index;
    }
  });

  return clubIndex;
};

const normalizeSubject = (value: string | null | undefined): string => {
  const subject = value?.trim();
  if (!subject) return "";

  const normalized = subject.toLowerCase();
  if (normalized === "maths" || normalized === "mathematics") return "Mathematics";
  if (normalized === "english" || normalized === "eng") return "English";
  return subject;
};

const normalizeAssessmentStatus = (subject: string, status: string): string => {
  const trimmedStatus = status?.trim();
  if (!trimmedStatus) return trimmedStatus;

  const subjectName = normalizeSubject(subject);
  const upperStatus = trimmedStatus.toUpperCase();

  if (subjectName === "English") {
    return upperStatus
      .replace(/\bRESUME\s+MD\b/g, "RESUME EC")
      .replace(/\bMD\b/g, "EC")
      .replace(/MATHS DOCTOR/gi, "English Check")
      .replace(/MATHS/gi, "ENGLISH")
      .replace(/EC\s+ASSESSMENT/gi, "English Check");
  }

  if (subjectName === "Mathematics") {
    return upperStatus
      .replace(/\bRESUME\s+EC\b/g, "RESUME MD")
      .replace(/\bEC\b/g, "MD")
      .replace(/ENGLISH CHECK/gi, "Maths Doctor")
      .replace(/ENGLISH/gi, "MATHS")
      .replace(/MD\s+ASSESSMENT/gi, "Maths Doctor");
  }

  return trimmedStatus;
};

const isWlpFieldUnset = (value: string | null | undefined): boolean =>
  value == null || ["", "N"].includes(value.trim().toUpperCase());

interface ReportData {
  subject: string;
  leftArrowText: string;
  rightArrowText: string;
  bannerColor: string;
  bannerImage: string;
  containerImage: string;
  showLeftArrow: boolean;
  showRightArrow: boolean;
  redirect?: string;
}

const StudyRoom: React.FC = () => {
  const navigate = useNavigate();
  const [trophyVisible, setTrophyVisible] = useState(false);
  const [coinsCollected, setCoinsCollected] = useState(false);
  const [wlpcompleted_coins, setWlpcompletedCoins] = useState(false);
  const [wtaVisible] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [rewardPoints, setRewardPoints] = useState(1500);
  const [trophy, setTrophy] = useState<string | null>(null);
  const [sameTrophyClub, setSameTrophyClub] = useState(false);
  const [pendingPoints, setPendingPoints] = useState<number | null>(null);
  const [overallWeeklyProgress, setOverallWeeklyProgress] = useState(0);
  const [weekCount, setWeekCount] = useState(0);
  const [trophyData, setTrophyData] = useState<string[]>([]);
  const [userName, setUserName] = useState<string>("");
  const [purchases, setPurchases] = useState<string | null>(null);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [rewardLoading, setRewardLoading] = useState(false);
  const [isAssessmentStatusLoaded, setIsAssessmentStatusLoaded] =
    useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isMathsDoctorDropdownOpen, setIsMathsDoctorDropdownOpen] =
    useState<boolean>(false);
  const [MathsDoctorBtnText, setMathsDoctorBtnText] = useState<string>("");
  const [WlpData, setWlpData] = useState<WlpResponse | null>(null);
  const [WlpBtnText, setWlpBtnText] = useState<string>("");
  const currentActivity = WlpData?.activities?.find(
    (activity) => activity.is_current === true
  ) ?? WlpData?.activities?.find(
    (activity) =>
      isWlpFieldUnset(activity.completedflag) &&
      isWlpFieldUnset(activity.howshifted)
  );
  const [WlpProgress, setWlpProgress] = useState<string>("");
  const [subjects, setSubjects] = useState<string[]>([]);
  const [currentSubject, setCurrentSubject] = useState<string>(
    () => {
      clearCachedAssessmentStatuses();
      return normalizeSubject(sessionStorage.getItem("Subject"));
    }
  );
  const [subjectBannerImage, setSubjectBannerImage] = useState<string>("");
  const [subjectBannerColor, setSubjectBannerColor] =
    useState<string>("#a41919");
  const [reportData, setReportData] = useState<ReportData | null>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const SECRET_ENCRYPTION_KEY = "6GJZIa6J7NZzTdzf4K7Em6y6XiqwT09wqkKkNHaAvjE=";
  const apiUrl =
    process.env.REACT_APP_DOCUMENT_LINK ;
  const [contentHeight, setContentHeight] = useState(0);
  const [nextWlpActivity, setNextWlpActivity] = useState<Activity | null>(null);
  const [mdStatus, setMdStatus] = useState({
    ReportNo: null,
    StartWLP: null,
    MDStatus: null,
  });
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showBackToBottom, setShowBackToBottom] = useState(true);
  const scrollContainerRef = useRef<HTMLElement | null>(null);
  const [showMDCompletionMessage, setShowMDCompletionMessage] =
    useState<boolean>(false);
  const [activeSection, setActiveSection] = useState<"MD" | "EC" | "WLP" | null>(null);
  const [ecStatus, setEcStatus] = useState<string>("");
  const [EnglishCheckBtnText, setEnglishCheckBtnText] = useState<string>("");

  const getTrophyImage = (points: number) => {
    if (points >= 5000) return trophy_club_large_5000;
    if (points >= 4500) return trophy_club_large_4500;
    if (points >= 4000) return trophy_club_large_4000;
    if (points >= 3000) return trophy_club_large_3000;
    if (points >= 2500) return trophy_club_large_2500;
    if (points >= 2000) return trophy_club_large_2000;
    if (points >= 1500) return trophy_club_large_1500;
    if (points >= 1250) return trophy_club_large_1250;
    if (points >= 1000) return trophy_club_large_1000;
    if (points >= 750) return trophy_club_large_750;
    return trophy_club_large_500;
  };

  // useEffect(() => {
  //   console.log("State updated:", { trophyVisible, isVisible });
  // }, [trophyVisible, isVisible]);

  useEffect(() => {
    const preload = [
      "https://staging.elearnoncloud.com/STUDENT/MSR/Image/wlp_arrow_down.png",
      "https://staging.elearnoncloud.com/STUDENT/MSR/Image/wlp_arrow_up.png",
    ];
    preload.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    const fetchWeeklyProgress = async () => {
      const login = sessionStorage.getItem("Login");
      const familyCode = sessionStorage.getItem("FamilyCode");
      const schoolCode = sessionStorage.getItem("SchoolCode");
      const accessToken = localStorage.getItem("access_token");

      if (!login || !familyCode || !schoolCode) return;

      try {
        const response = await fetch(`${apiUrl}get_weekly_progress/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
          },
          body: JSON.stringify({
            Login: login,
            FamilyCode: familyCode,
            SchoolCode: schoolCode
          }),
        });

        const data = await response.json();

        if (data && data.WeeklyProgress != null) {
          sessionStorage.setItem("WeeklyProgress", data.WeeklyProgress.toString());
        }
      } catch (error) {
        console.error("Error fetching weekly progress:", error);
      }
    };

    fetchWeeklyProgress();
  }, []);

  const refreshStudentPoints = async () => {
    const login = sessionStorage.getItem("Login");
    const familyCode = sessionStorage.getItem("FamilyCode");
    const schoolCode = sessionStorage.getItem("SchoolCode");

    if (!login || !familyCode || !schoolCode) return;

    try {
      const response = await fetch(`${apiUrl}totalTrophyCount_Points/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Login: login,
          FamilyCode: familyCode,
          SchoolCode: schoolCode,
        }),
      });
      if (typeof response.json !== "function") return;
      const data = await response.json();

      if (response.ok && data) {
        if (data.currentpoints != null) {
          sessionStorage.setItem("CurrentPoints", data.currentpoints.toString());
        }
        if (data.totaltrophycount != null) {
          sessionStorage.setItem("TotalTrophyCount", data.totaltrophycount.toString());
        }
        if (data.plan != null) {
          sessionStorage.setItem("Plan", data.plan);
        }
      }
    } catch (error) {
      console.error("Error refreshing student points:", error);
    }
  };

  useEffect(() => {
    const lastPage = new URLSearchParams(window.location.search).get("lastPage");
    if (lastPage !== "Assessment") {
      return;
    }

    const clearCompletionCaches = async () => {
      const schoolCode = sessionStorage.getItem("SchoolCode");
      const familyCode = sessionStorage.getItem("FamilyCode");
      const login = sessionStorage.getItem("Login");

      if (!schoolCode || !familyCode || !login) return;

      try {
        await fetch(`${apiUrl}clear_cache/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            SchoolCode: schoolCode,
            FamilyCode: familyCode,
            Login: login,
            Caches: ["all_user"],
          }),
        });
      } catch (error) {
        console.error("Error clearing completion caches:", error);
      }

      sessionStorage.removeItem("CurrentPoints");
      sessionStorage.removeItem("TotalTrophyCount");
      await refreshStudentPoints();

      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete("lastPage");
      const newUrl =
        window.location.pathname +
        (searchParams.toString() ? `?${searchParams.toString()}` : "");
      window.history.replaceState({}, "", newUrl);
    };

    clearCompletionCaches();
  }, [apiUrl]);

  useEffect(() => {
    const content = contentRef.current;
    if (!content) return;

    const updateContentHeight = () => {
      setContentHeight(content.scrollHeight);
    };

    const frameId = window.requestAnimationFrame(updateContentHeight);
    const resizeObserver = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(updateContentHeight)
      : null;
    resizeObserver?.observe(content);

    return () => {
      window.cancelAnimationFrame(frameId);
      resizeObserver?.disconnect();
    };
  }, [WlpData]);

  const toggleWlpList = () => {
    if (trophyVisible || wlpcompleted_coins) return;

    if (!isVisible && contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }

    setIsVisible((visible) => !visible);
  };

  useEffect(() => {
    const candidates: (HTMLElement | null)[] = [
      (document.scrollingElement as HTMLElement) || null,
      document.getElementById("contents_math"),
      document.getElementById("main_top_container"),
      document.getElementById("contents_english"),
      document.getElementById("contents_physics"),
      document.getElementById("contents_chemistry"),
      document.getElementById("contents_biology"),
      document.body,
      document.documentElement,
    ];

    let container: HTMLElement | null = null;
    for (const element of candidates) {
      if (!element) continue;

      const style = window.getComputedStyle(element);
      const isScrollable =
        style.overflowY === "auto" ||
        style.overflowY === "scroll" ||
        style.overflowY === "overlay" ||
        style.overflowY === "visible";
      if (element.scrollHeight > element.clientHeight && isScrollable) {
        container = element;
        break;
      }
    }
    const scrollContainer =
      container ||
      (document.scrollingElement as HTMLElement) ||
      document.documentElement;
    scrollContainerRef.current = scrollContainer;

    const handleScroll = () => {
      const element =
        scrollContainerRef.current ||
        (document.scrollingElement as HTMLElement) ||
        document.documentElement;
      const scrollTop = element.scrollTop;
      const innerHeight = element.clientHeight || window.innerHeight;
      const scrollable = Math.max(0, element.scrollHeight - innerHeight);
      const tolerance = 6;
      const atTop = scrollTop <= tolerance;
      const ratio = scrollable <= 0 ? 0 : scrollTop / scrollable;

      if (atTop || ratio < 0.5) {
        setShowBackToBottom(true);
        setShowBackToTop(false);
      } else {
        setShowBackToTop(true);
        setShowBackToBottom(false);
      }
    };

    let listeningOnWindow = false;
    try {
      scrollContainer.addEventListener("scroll", handleScroll, { passive: true });
    } catch {
      window.addEventListener("scroll", handleScroll, { passive: true });
      listeningOnWindow = true;
    }

    const initialUpdate = window.setTimeout(handleScroll, 0);
    return () => {
      window.clearTimeout(initialUpdate);
      if (listeningOnWindow) {
        window.removeEventListener("scroll", handleScroll);
      } else {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
      scrollContainerRef.current = null;
    };
  }, []);

  useEffect(() => {
    const handler = () => {
      setCurrentSubject(normalizeSubject(sessionStorage.getItem("Subject")));
    };
    window.addEventListener("subjectChange", handler);
    return () => window.removeEventListener("subjectChange", handler);
  }, []);

  const handleStartMDSetWork = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const calledFrom = "~/STUDENT/MSR/StudyRoom?Subject=Mathematics";
    navigate(
      `/MathsDoctor/Assessment/ConfirmAssessment?CalledFrom=${encodeURIComponent(
        calledFrom
      )}`
    );
  };

  const handleStartECSetWork = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const calledFrom = "~/STUDENT/MSR/StudyRoom?Subject=English";
    navigate(
      `/EnglishCheck/Assessment/ConfirmECAssessment?CalledFrom=${encodeURIComponent(
        calledFrom
      )}`
    );
  };

  const handleScienceClick = (topic: string) => {
    // Navigate to ExploreActivities with the specific Science topic
    // Note: Legacy code had a bug swapping Phys/Biol; this uses the logical mapping.
    navigate(`/STUDENT/MSR/ExploreActivities?Subject=Science&Topic=${topic}`);
  };

  const getActivityLink = (activity: Activity): string => {
    const { activitytype, lessoncode, DicCode, ChildShortDesc } = activity;

    const returnParams = new URLSearchParams(window.location.search);
    if (currentSubject) {
      returnParams.set("Subject", currentSubject);
    }
    const currentPath =
      window.location.pathname +
      (returnParams.toString() ? `?${returnParams.toString()}` : "");
    const calledFromParam = `&calledFrom=${encodeURIComponent(currentPath)}`;
    const dicFileVersionParam = sessionStorage.getItem("DICFileVersion") || 1;

    const hwidParam = "&hwid=0";

    if (activitytype === "G") {
      return `/STUDENT/Tutorials/Game?LsnTestCode=${lessoncode + "_E"
        }${calledFromParam}${hwidParam}`;
    }
    if (activitytype === "T") {
      return `/STUDENT/Tutorials/ConfirmTest?DicCode=${DicCode}&LsnTestCode=${lessoncode}&DicVersion=${dicFileVersionParam}&name=${encodeURIComponent(
        ChildShortDesc
      )}${calledFromParam}${hwidParam}`;
    }
    if (activitytype === "L") {
      const lessonCalledFrom = `&calledFrom=${encodeURIComponent(currentPath)}`;
      return `/STUDENT/Tutorials/Tutorial?id=${lessoncode + "_E"
        }&DicVersion=${dicFileVersionParam}&name=${encodeURIComponent(
          ChildShortDesc
        )}&folder=${DicCode}${lessonCalledFrom}${hwidParam}`;
    }
    return "";
  };

  const getActivityLinks = (activity: Activity): string => {
    const { activitytype, lessoncode, DicCode } = activity;
    if (activitytype === "G") {
      return `/STUDENT/Tutorials/Game?LsnTestCode=${lessoncode + "_E"
        }?calledFrom=${encodeURIComponent("/STUDENT/MSR/StudyRoom")}`;
    }
    if (activitytype === "T") {
      return `/STUDENT/Tutorials/ConfirmTest?DicCode=${DicCode}&LsnTestCode=${lessoncode}&name=${activity.ChildShortDesc
        }?calledFrom=${encodeURIComponent("/STUDENT/MSR/StudyRoom")}`;
    }
    if (activitytype === "L") {
      return `/STUDENT/Tutorials/Tutorial?id=${lessoncode + "_E"}&name=${activity.ChildShortDesc
        }?calledFrom=${encodeURIComponent("/STUDENT/MSR/StudyRoom")}`;
    }
    return "";
  };

  const handleStartActivity = (activity: Activity) => {
    sessionStorage.setItem("LsnTestCode", activity.lessoncode || "");
    sessionStorage.setItem("UnitCode", activity.unitcode || "");
    sessionStorage.setItem("ChapterCode", activity.chaptercode || "");
    sessionStorage.setItem("DICFileVersion", "1");
    if (activity.DicCode) {
      sessionStorage.setItem("SelectedDICFile", activity.DicCode);
    }

    const link = getActivityLink(activity);
    navigate(link);
  };

  const fetchTrophyStatus = () => {
    const normalizedSubject = normalizeSubject(sessionStorage.getItem("Subject"));
    const previousTrophyCount = Number(
      sessionStorage.getItem("TotalTrophyCount") || "0"
    );
    setRewardLoading(true);

    fetch(`${apiUrl}get_trophy_status/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        SchoolCode: sessionStorage.getItem("SchoolCode"),
        FamilyCode: sessionStorage.getItem("FamilyCode"),
        Login: sessionStorage.getItem("Login"),
        PreviousTrophyCount: previousTrophyCount,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          if (data.BonusPoints) {
            sessionStorage.setItem("RewardPoints", data.BonusPoints.toString());
            setRewardPoints(data.BonusPoints);
          }

          const currentPoints = Number(
            data.CurrentPoints ??
              Number(sessionStorage.getItem("CurrentPoints") || "0") +
                Number(data.BonusPoints || 0)
          );
          setPendingPoints(currentPoints);

          if (
            data.TotalTrophyCount !== undefined &&
            data.TotalTrophyCount !== null
          ) {
            const totalTrophyCount = Number(data.TotalTrophyCount);
            const previousClubIndex = getTrophyClubIndex(previousTrophyCount);
            const currentClubIndex = getTrophyClubIndex(totalTrophyCount);
            const isSameTrophyClub =
              data.SameTrophyClub ?? currentClubIndex === previousClubIndex;

            sessionStorage.setItem(
              "TotalTrophyCount",
              totalTrophyCount.toString()
            );
            window.dispatchEvent(new Event("trophyStatusUpdated"));
            setSameTrophyClub(isSameTrophyClub);

            if (!isSameTrophyClub) {
              setTrophy(trophyClubMinimums[currentClubIndex].toString());
              setTrophyVisible(true);
              setWlpcompletedCoins(false);
            } else {
              setTrophy(null);
              setTrophyVisible(false);
              setWlpcompletedCoins(true);
            }
          }
          if (normalizedSubject === "English") {
            sessionStorage.setItem("English_wlp_status", "C");
          }
          if (normalizedSubject === "Mathematics") {
            sessionStorage.setItem("Maths_wlp_status", "C");
          }

          setCoinsCollected(false);
        }
      })
      .catch((error) => console.error("Error fetching trophy status:", error))
        .finally(() => setRewardLoading(false));
  };

  useEffect(() => {
    const subject = normalizeSubject(reportData?.subject);
    if (!subject) return;

    let isCurrentRequest = true;

    const fetchSubjectAssessmentFlow = async () => {
      setLoading(false);
      setWlpcompletedCoins(false);
      setTrophyVisible(false);
      setSameTrophyClub(false);
      setPendingPoints(null);

      const schoolCode = sessionStorage.getItem("SchoolCode");
      const familyCode = sessionStorage.getItem("FamilyCode");
      const login = sessionStorage.getItem("Login");

      if (!schoolCode || !familyCode || !login) return;

      try {
        if (subject !== "Mathematics" && subject !== "English") {
          console.warn("Skipping assessment request without a valid subject.");
          setActiveSection("WLP");
          setLoading(true);
          return;
        }

        const status = await fetchAssessmentStatus(
          apiUrl,
          schoolCode,
          familyCode,
          login,
          subject
        );
        if (!isCurrentRequest) return;

        const displayStatus = normalizeAssessmentStatus(subject, status);
        const normalizedStatus = displayStatus.toUpperCase();

        if (subject === "Mathematics") {
          setMathsDoctorBtnText(displayStatus);
        } else {
          setEnglishCheckBtnText(displayStatus);
          setEcStatus(displayStatus);
        }

        const resumeStatuses =
          subject === "Mathematics"
            ? ["GET STARTED", "RESUME", "RESUME MD"]
            : ["GET STARTED", "RESUME", "RESUME EC"];

        if (
          resumeStatuses.includes(normalizedStatus) ||
          normalizedStatus.includes("RESUME")
        ) {
          setActiveSection(subject === "Mathematics" ? "MD" : "EC");
          setWlpData(null);
          setWlpProgress("");
          setWlpBtnText("");
          setNextWlpActivity(null);
          setLoading(true);
          return;
        }

        if (
          ["NOT ASSIGNED", "COMPLETED"].includes(normalizedStatus) ||
          !normalizedStatus
        ) {
          if (subject !== "Mathematics" && subject !== "English") {
            console.warn("Skipping assigned_wlp request without a valid subject.");
            setLoading(true);
            return;
          }

          const wlpResponse = await fetch(`${apiUrl}assigned_wlp/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              SchoolCode: schoolCode,
              FamilyCode: familyCode,
              Login: login,
              Subject: subject,
            }),
          }).then((res) => res.json());
          if (!isCurrentRequest) return;

          if (!wlpResponse) {
            setActiveSection(subject === "Mathematics" ? "MD" : "EC");
            setWlpData(null);
            setWlpProgress("");
            setWlpBtnText("");
            setNextWlpActivity(null);
            setLoading(true);
            return;
          }

          setWlpData(wlpResponse);
          setWlpProgress(wlpResponse.completion_percentage || "");

          const nextActivity = wlpResponse?.activities?.find(
            (activity: Activity) => activity.is_current === true
          ) ?? wlpResponse?.activities?.find(
            (activity: Activity) =>
              isWlpFieldUnset(activity.completedflag) &&
              isWlpFieldUnset(activity.howshifted)
          );

          const progress = wlpResponse.completion_percentage
            ? parseInt(wlpResponse.completion_percentage)
            : 0;

          setNextWlpActivity(null);

          if (wlpResponse?.activities && wlpResponse.activities.length > 0) {
            if (nextActivity) {
              setNextWlpActivity(nextActivity);
              setWlpBtnText(nextActivity.ChildShortDesc);
            } else {
              setWlpBtnText("");
            }
          }

          const searchParams = new URLSearchParams(window.location.search);
          const lastPage = searchParams.get("lastPage");

          if (lastPage === "Result" || lastPage === "AnswerSheet") {
            if (progress === 100) {
              fetchTrophyStatus();
            }
            searchParams.delete("lastPage");
            const newUrl =
              window.location.pathname +
              (searchParams.toString() ? "?" + searchParams.toString() : "");
            window.history.replaceState({}, "", newUrl);
          }

          setActiveSection("WLP");
          setLoading(true);
          return;
        }

        setActiveSection(subject === "Mathematics" ? "MD" : "EC");
        setWlpData(null);
        setWlpProgress("");
        setWlpBtnText("");
        setNextWlpActivity(null);
        setLoading(true);
      } catch (error) {
        if (!isCurrentRequest) return;
        console.error("Error fetching subject assessment flow:", error);
        setLoading(true);
      }
    };

    fetchSubjectAssessmentFlow();
    return () => {
      isCurrentRequest = false;
    };
  }, [reportData?.subject]);

  useEffect(() => {
    const subject = normalizeSubject(reportData?.subject);
    if (!subject || (subject !== "Mathematics" && subject !== "English")) {
      setShowMDCompletionMessage(false);
      setMdStatus({ ReportNo: null, StartWLP: null, MDStatus: null });
      setIsAssessmentStatusLoaded(Boolean(subject));
      return;
    }

    let isCurrentRequest = true;

    const fetchMDStatus = async () => {
      setIsAssessmentStatusLoaded(false);
      const endpoint =
        subject === "Mathematics"
          ? `${apiUrl}get_latest_report_no/`
          : `${apiUrl}get_ec_latest_report_no/`;

      setShowMDCompletionMessage(false);

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            SchoolCode: sessionStorage.getItem("SchoolCode"),
            FamilyCode: sessionStorage.getItem("FamilyCode"),
            Login: sessionStorage.getItem("Login"),
          }),
        });
        const data = await response.json();
        if (!isCurrentRequest) return;

        const assessmentStatus = data?.MDStatus ?? "";

        setMdStatus({
          ReportNo: data.ReportNo,
          StartWLP: data.StartWLP,
          MDStatus: assessmentStatus,
        });

        const isAssessmentCompleted =
          data.ReportNo === 1 &&
          (data.StartWLP === null || data.StartWLP === 0) &&
          assessmentStatus === "C";

        setShowMDCompletionMessage(isAssessmentCompleted);
      } catch (error) {
        if (!isCurrentRequest) return;
        console.error("Error fetching assessment status:", error);
      } finally {
        if (isCurrentRequest) {
          setIsAssessmentStatusLoaded(true);
        }
      }
    };

    fetchMDStatus();
    return () => {
      isCurrentRequest = false;
    };
  }, [reportData?.subject]);

  const toggleDropdown = () => {
    setIsMathsDoctorDropdownOpen(!isMathsDoctorDropdownOpen);
  };

  const handleClickOutside = (e: MouseEvent | TouchEvent) => {
    if (!(e.target instanceof Element)) return;
    if (!e.target.closest("#mobile_box") && !e.target.closest("#mobile_menu")) {
      setIsMenuVisible(false);
    }
  };

  const handleTrophyOkClick = () => {
    setWlpcompletedCoins(true);
    setTrophyVisible(false);
    setTimeout(() => setIsVisible((prev) => !prev), 0);
  };

  const handleWlpCompletedCoins = () => {
    setCoinsCollected(false);
    setWlpcompletedCoins(false);
    setTrophyVisible(false);
    setPendingPoints(null);
  };

  const handleCollectCoins = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (coinsCollected) return;

    setCoinsCollected(true);
    if (pendingPoints !== null) {
      sessionStorage.setItem("CurrentPoints", pendingPoints.toString());
      window.dispatchEvent(new Event("pointsUpdated"));
    }
    window.setTimeout(handleWlpCompletedCoins, 2700);
  };

  const handleExploreActivity = () => {
    navigate("/STUDENT/MSR/ExploreActivities");
  };

  const handleSkilledBUildGames = () => {
    navigate("/STUDENT/MSR/SkillBuildingGames");
  };

  const handleDoAgainClick = () => {
    navigate("/STUDENT/MSR/DoAgainPage", { state: { data: WlpData } });
  };

  const assessmentName =
    activeSection === "EC" ? "English Check" : "Math Doctor";
  const hasWlpContent =
    (WlpData?.activities?.length ?? 0) > 0 ||
    (WlpData?.extra_activities?.length ?? 0) > 0;
  const shouldResumeWlpActivity =
    nextWlpActivity?.lesson_status === "in-progress" ||
    nextWlpActivity?.completedflag === "D";
  const shouldRetryWlpActivity =
    nextWlpActivity?.lastscore !== null &&
    nextWlpActivity?.lastscore !== undefined;
  const wlpActivityTip = shouldRetryWlpActivity
    ? "Try again"
    : Number(WlpData?.completion_percentage) === 0
      ? "Here is your first activity"
      : "New activity";
  const shouldShowWlpGenerating =
    activeSection === "WLP" && !hasWlpContent;
  const isPageDataLoaded = loading && isAssessmentStatusLoaded;

  return (
    <form>
      {rewardLoading && <Loading />}

      <div id="main_top_container">
        <div>
          <Header />
          <a
            href="#bottom"
            className="back-to-bottom"
            onClick={(e) => {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = (container as any).scrollHeight;
                (document.body as any).scrollTop = document.body.scrollHeight;
              }, 400);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
                try {
                  container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
                } catch {
                  window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
                }
                setTimeout(() => {
                  (container as any).scrollTop = (container as any).scrollHeight;
                  (document.body as any).scrollTop = document.body.scrollHeight;
                }, 400);
              }
            }}
            aria-label="Back to bottom"
            role="button"
            tabIndex={0}
            style={{
              opacity: showBackToBottom ? 1 : 0,
              transform: showBackToBottom ? 'translateY(0)' : 'translateY(8px)',
              display: 'block',
              cursor: 'pointer',
              zIndex: 2147483647,
              pointerEvents: showBackToBottom ? 'auto' : 'none',
              position: 'fixed',
              left: 20,
              bottom: 20,
              transition: 'opacity 240ms ease, transform 240ms ease',
              boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
            }}
          >
            Back to Bottom
          </a>

          <a
            href="#top"
            className="back-to-top"
            onClick={(e) => {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: 0, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = 0;
                (document.body as any).scrollTop = 0;
              }, 300);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
                try {
                  container.scrollTo({ top: 0, behavior: 'smooth' });
                } catch {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
                setTimeout(() => {
                  (container as any).scrollTop = 0;
                  (document.body as any).scrollTop = 0;
                }, 300);
              }
            }}
            aria-label="Back to top"
            role="button"
            tabIndex={0}
            style={{
              opacity: showBackToTop ? 1 : 0,
              transform: showBackToTop ? 'translateY(0)' : 'translateY(8px)',
              display: 'block',
              cursor: 'pointer',
              zIndex: 2147483647,
              pointerEvents: showBackToTop ? 'auto' : 'none',
              position: 'fixed',
              right: 20,
              bottom: 20,
              transition: 'opacity 240ms ease, transform 240ms ease',
              boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
            }}
          >
            Back to Top
          </a>
        </div>
        <Section />
        <SubHeader
          pageType="studyroom"
          onDataLoaded={setReportData}
          hideArrows={showMDCompletionMessage}
        >
          {showMDCompletionMessage && isPageDataLoaded && (
            <div style={{ padding: "20px" }}>
              <div id="Div2" className="subject_container_title">
                <p>🎉 Congratulations!</p>
                <br />
                <br />
                <p>You’ve successfully completed the {assessmentName} Assessment.</p>
                <p>
                  ✅ The next step: Your tutor will give you a call to review
                  your results and get you started with your personalized
                  learning plan.
                </p>
              </div>
            </div>
          )}

          {(!showMDCompletionMessage || !isPageDataLoaded) && (
            <>
              {isPageDataLoaded ? (
                <div>
                  <div>
                    {/* <div className="subject_middle_gap"></div> */}
                    {wlpcompleted_coins && (
                      <div
                        style={{ display: "block", overflow: "hidden" }}
                        // id="WLP_completed_maths_reward_overlay"
                        id={`WLP_completed_${currentSubject}_reward_overlay`}
                        data-example-completed-wlp-only="no"
                      >
                        <div className="subject_container_title">
                          <p>WELL DONE ON COMPLETING YOUR WEEKLY LESSON PLAN</p>
                        </div>
                        <div className="subject_container_text">
                          <span id="spntrophycoins">
                            Click the coins to collect your points
                          </span>
                        </div>
                        <div id="WLP_completed_english_reward_div">
                          <div id="trophy_rays"></div>
                          <div
                            id="wlp_reward_trophy"
                            className={`wlp_reward_trophy_trophy${sameTrophyClub ? "" : " wlp_reward_trophy_coins"}${coinsCollected ? " trophy_scale_ie" : ""}`}
                            onClick={handleCollectCoins}
                          >
                            <div id="wlp_reward_trophy_amount_spacer"></div>
                            <div
                              id="wlp_reward_trophy_amount"
                              className="wlp_reward_trophy_amount_font_colour"
                            >
                              {rewardPoints}
                            </div>
                            <div
                              id="wlp_reward_trophy_amount_subtitle"
                              className="wlp_reward_trophy_amount_subtitle_font_colour"
                            >
                              Points
                            </div>
                          </div>
                          <div id="trophy_shadow"></div>
                          <div id="trophy_coin_container" className={coinsCollected ? "trophy_coin_container_ie" : ""}>
                            <div
                              id="trophy_coin01"
                              className={`trophy_coin${coinsCollected ? " trophy_coin_collect" : ""}`}
                            ></div>
                            <div
                              id="trophy_coin02"
                              className={`trophy_coin${coinsCollected ? " trophy_coin_collect" : ""}`}
                            ></div>
                            <div
                              id="trophy_coin03"
                              className={`trophy_coin${coinsCollected ? " trophy_coin_collect" : ""}`}
                            ></div>
                            <div
                              id="trophy_coin04"
                              className={`trophy_coin${coinsCollected ? " trophy_coin_collect" : ""}`}
                            ></div>
                            <div
                              id="trophy_coin05"
                              className={`trophy_coin${coinsCollected ? " trophy_coin_collect" : ""}`}
                            ></div>
                            <div
                              id="trophy_coin06"
                              className={`trophy_coin${coinsCollected ? " trophy_coin_collect" : ""}`}
                            ></div>
                          </div>
                          <div id="dot_container">
                            <div className="dot" id="dot01"></div>
                            <div className="dot" id="dot02"></div>
                            <div className="dot" id="dot03"></div>
                            <div className="dot" id="dot04"></div>
                            <div className="dot" id="dot05"></div>
                            <div className="dot" id="dot06"></div>
                            <div className="dot" id="dot07"></div>
                            <div className="dot" id="dot08"></div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!trophyVisible && !wlpcompleted_coins && (
                      <div>
                        {reportData &&
                          reportData.subject === "Science" &&
                          wlpcompleted_coins === false ? (
                          <div>
                            <a
                              href="#"
                              id="linkbtnStartPhysics"
                              className="activity_btn"
                              onClick={(e) => {
                                e.preventDefault();
                                handleScienceClick("Phys");
                              }}
                            >
                              <span
                                id="physics_wlp_icon"
                                className="activity_icon activity_iconT activity_icon_physics"
                                style={{ marginTop: "15px" }}
                              ></span>
                              <span className="lesson-text">PHYSICS</span>
                            </a>
                            <a
                              href="#"
                              id="linkbtnStartChemistry"
                              className="activity_btn"
                              onClick={(e) => {
                                e.preventDefault();
                                handleScienceClick("Chem");
                              }}
                            >
                              <span
                                id="chemistry_wlp_icon"
                                className="activity_icon activity_iconT activity_icon_chemistry"
                                style={{ marginTop: "15px" }}
                              ></span>
                              <span className="lesson-text">CHEMISTRY</span>
                            </a>
                            <a
                              href="#"
                              id="linkbtnStartBiology"
                              className="activity_btn"
                              onClick={(e) => {
                                e.preventDefault();
                                handleScienceClick("Biol");
                              }}
                            >
                              <span
                                id="biology_wlp_icon"
                                className="activity_icon activity_iconT activity_icon_biology"
                                style={{ marginTop: "15px" }}
                              ></span>
                              <span className="lesson-text">BIOLOGY</span>
                            </a>
                          </div>
                        ) : (
                          <div className="subject_based_div">
                            {(activeSection === "MD" || activeSection === "EC") &&
                              normalizeSubject(sessionStorage.getItem("Subject")) !== "" ? (
                              <div id="panelSetWorkMDContainer">
                                <div className="subject_container_title">
                                  <p>Your Teacher/Tutor Has Set Work For You</p>
                                </div>
                                <div
                                  id="math_setwork_dropdown"
                                  className="setwork_dropdown"
                                  onClick={toggleDropdown}
                                  style={{
                                    backgroundImage: isMathsDoctorDropdownOpen
                                      ? "url('https://staging.elearnoncloud.com/STUDENT/MSR/Image/wlp_arrow_up.png')"
                                      : "",
                                    transition:
                                      "background-image 0.5s ease-in-out",
                                  }}
                                >
                                  <div className="setwork_title_container">
                                    <span id="math_setwork_title">
                                    {(activeSection === "EC"
                                      ? "English Check"
                                      : "Maths Doctor")} Assessment
                                    </span>
                                  </div>
                                </div>
                                {isMathsDoctorDropdownOpen && (
                                  <div
                                    id="math_list_setwork_groups"
                                    className="setwork_groups_list_container"
                                    style={{ display: "block" }}
                                  >
                                    <div
                                      id="math_setwork_groups_list_item_msr_s_0601a_row_01"
                                      className="setwork_groups_list_item_row_md"
                                    >
                                      <div className="setwork_groups_list_current_activity_name">
                                        <p>
                                          <span id="maths_setwork">
                                            {(activeSection === "EC"
                                              ? "English Check"
                                              : "Maths Doctor")} Assessment
                                          </span>
                                        </p>
                                      </div>
                                      <div className="setwork_groups_list_current_activity_duedate">
                                        <p>
                                          <span>-</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="subject_container_text">
                                  <p id="math_setwork_selected_set_text"></p>
                                </div>
                                <a
                                  href="#"
                                  id="linkbtnStartMDSetWork"
                                  className="activity_btn setwork_btn"
                                  onClick={activeSection === "EC" ? handleStartECSetWork : handleStartMDSetWork}
                                >
                                  <span
                                    id="math_wlp_icon"
                                    className="activity_icon activity_icon_md"
                                    style={{ cursor: "pointer" }}
                                  ></span>
                                  <label
                                    id="lblbtnStartActivity11And12HeaderText"
                                    className="lesson-text"
                                    style={{ cursor: "pointer" }}
                                  >
                                    {(activeSection === "EC"
                                      ? "English Check"
                                      : "Maths Doctor")} (Assessment)
                                  </label>
                                  <span className="button_right_text button_right_textT">
                                    <span id="lblStartMDSetWorkText"
                                      ref={(el) => {
                                        if (el) {
                                          el.style.setProperty("padding", "0 10px 0 20px", "important");
                                        }
                                      }}
                                    >
                                      {activeSection === "EC" ? EnglishCheckBtnText : MathsDoctorBtnText}
                                    </span>
                                  </span>
                                </a>

                                <div className="subject_inner_hr" style={{margin:"20px"}}></div>


                                {/* <div className="subject_inner_hr"></div> */}
                                <div
                                  id="divWLPSubjectContainerTitle"
                                  className="subject_container_title"
                                >
                                  <p id="pSubjectContainerTitle" style={{marginBottom:"3px"}}>
                                    This Week's Activities
                                  </p></div>

                                <div
                                  id="divWLPSubjectContainerTextMD"
                                  className="subject_container_text"
                                >
                                  <p id="pSubjectContainerTextMD">
                                    {activeSection === "EC"
                                      ? "English Check has been set by your teacher/tutor. Please complete English Check."
                                      : "Math Doctor has been set by your teacher/tutor. Please complete Math Doctor, and we will create a new lesson plan for you."}
                                  </p>
                                </div>


                                <div
                                  className="subject_inner_hr"
                                  style={{ marginTop: "30px" , marginBottom: "0px" }}
                                ></div>
                              </div>
                            ) : (
                              <div>
                                {hasWlpContent ? (
                                  <div id="divWLPActivity">
                                    <div
                                      id="divWLPSubjectContainerTitle"
                                      className="subject_container_title"
                                    >
                                      <p id="pSubjectContainerTitle">
                                        {parseInt(WlpProgress) === 100
                                          ? "This Week's Activities Completed!"
                                          : "This Week's Activities"}
                                      </p>
                                    </div>
                                    <div
                                      id="divWLPSubjectContainerTextMD"
                                      className="subject_container_text"
                                    ></div>
                                    <div
                                      id="divWLPSubjectContainerTextParent"
                                      className="subject_container_text"
                                    >
                                      <p id="pSubjectContainerTextParent">
                                        {parseInt(WlpProgress) === 100
                                          ? ""
                                          : "Do your best to finish before Sunday night"}
                                      </p>
                                    </div>
                                    <div
                                      id="divWLPCompletedContainer"
                                      className="WLP_completed_box"
                                      style={{
                                        display:
                                          parseInt(WlpProgress) === 100
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      <p>Weekly lesson plan completed</p>
                                    </div>
                                    <div
                                      id="divWLPActivityTipContainer"
                                      className="activity_btn_and_tip_container_WLP"
                                      style={{
                                        display:
                                          parseInt(WlpProgress) === 100
                                            ? "none"
                                            : "block",
                                      }}
                                    >
                                      <div
                                        className="tip_container"
                                        id="tip_containerT"
                                      >
                                        <span>{wlpActivityTip}</span>
                                      </div>
                                      <div
                                        id="linkbtnWLPStartActivity"
                                        className="activity_btn"
                                        onClick={() => {
                                          if (nextWlpActivity) {
                                            handleStartActivity(
                                              nextWlpActivity
                                            );
                                          }
                                        }}
                                      >
                                        <span
                                          id="lblWLPActivityIcon"
                                          className={`activity_icon ${nextWlpActivity?.activitytype?.toLowerCase() ===
                                              "t"
                                              ? "wlp_list_current_activity_icon_test"
                                              : nextWlpActivity?.activitytype?.toLowerCase() ===
                                                "g"
                                                ? "wlp_list_current_activity_icon_game"
                                                : "wlp_list_current_activity_icon_lesson"
                                            }`}
                                          style={{ cursor: "pointer" }}
                                        ></span>

                                        <label
                                          id="lblWLPActivityText"
                                          className="lesson-text"
                                          style={{ cursor: "pointer" }}
                                        >
                                          {WlpBtnText}
                                        </label>
                                        <span
                                          className="button_right_text button_right_textT button_right_textWLP"
                                          style={{ display: "block" }}
                                        >
                                          <span id="lblStartBtnText" >
                                            {/* {shouldResumeWlpActivity ? "Resume" : "GET STARTED"} */}
                                            {/* <label></label>{shouldResumeWlpActivity ? "RESUME " : "GET STARTED"} */}
                                            {shouldResumeWlpActivity ? <label id='button_right_textWLP'>Resume</label> :<label>GET STARTED</label>}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      id="divlesson_plan_progress_container_WLP"
                                      className="lesson_plan_progress_container_WLP"
                                    >
                                      <div
                                        id="user_lesson_plan_progress_bar"
                                        className="lesson_plan_progress_bar"
                                        style={{ width: `${WlpProgress}%` }}
                                      ></div>
                                    </div>
                                    <div
                                      id="divWLPDropDownMenuBar"
                                      className="view_full_plan_bar_WLP"
                                      onClick={toggleWlpList}
                                      style={{
                                        backgroundImage: !isVisible
                                          ? "url('https://staging.elearnoncloud.com/STUDENT/MSR/Image/wlp_arrow_down.png')"
                                          : "url('https://staging.elearnoncloud.com/STUDENT/MSR/Image/wlp_arrow_up.png')",
                                        transition:
                                          "background-image 0.3s ease-in-out",
                                      }}
                                    >
                                      <span>Weekly Lesson Plan </span>
                                      <span className="wlp_text wlp_textT">
                                        {WlpData?.done_summary}
                                      </span>
                                    </div>

                                    <div
                                      id="english_lesson_plan_list"
                                      className="lesson_plan_list_container"
                                      ref={contentRef}
                                      style={{
                                        maxHeight: isVisible
                                          ? `${contentHeight}px`
                                          : "0px",
                                        opacity: isVisible ? 1 : 0,
                                        overflow: "hidden",
                                        transition:
                                          "max-height 0.5s ease-in-out, opacity 0.3s ease-in-out, transform 0.4s ease-in-out",
                                        transform: isVisible
                                          ? "translateY(0)"
                                          : "translateY(-5px)",
                                        display: "block",
                                      }}
                                    >
                                      {WlpData?.activities?.map(
                                        (activity, index) => (
                                          <div
                                            className="wlp_list_item_row"
                                            key={index}
                                            style={{
                                              height: "27px !important",
                                            }}
                                          >
                                            <div
                                              className={
                                                `wlp_list_current_activity_box ` +
                                                (Number(
                                                  WlpData?.completion_percentage
                                                ) === 100
                                                  ? ""
                                                : activity === currentActivity
                                                  ? "wlp_list_current_activity_arrow"
                                                  : "")
                                              }
                                            >
                                              {WlpBtnText ===
                                                activity.ChildShortDesc &&
                                                activity.lessoncode ===
                                                  currentActivity?.lessoncode ? (
                                                <span
                                                  style={{ color: "#576D90" }}
                                                >
                                                  .
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </div>

                                            <div
                                              className={`wlp_list_current_activity_icon ${activity.activitytype?.toLowerCase() ===
                                                  "t"
                                                  ? "wlp_list_current_activity_icon_test"
                                                  : activity.activitytype?.toLowerCase() ===
                                                    "g"
                                                    ? "wlp_list_current_activity_icon_game"
                                                    : "wlp_list_current_activity_icon_lesson"
                                                }`}
                                            ></div>

                                            <div className="wlp_list_current_activity_name">
                                              <p>{activity.ChildShortDesc}</p>
                                            </div>

                                            <div className="wlp_list_current_activity_percentage">
                                              {/* 
                                    <p style={{ paddingTop: "3px !important" }}>
                                      {activity.lastscore !== null
                                        ? `${activity.lastscore}%`
                                        : ""}
                                    </p> */}
                                              <p
                                                style={{
                                                  height: 27,
                                                  lineHeight: "27px", // <-- centers the text vertically
                                                  display: "block",
                                                  overflow: "hidden",
                                                }}
                                                className={
                                                  activity.activitytype ===
                                                    "G" &&
                                                    activity.completedflag !==
                                                    null &&
                                                    activity.lastscore !== null
                                                    ? "list_crown"
                                                    : ""
                                                }
                                              >
                                                {activity.activitytype ===
                                                  "G" &&
                                                  activity.lastscore !== null ? (
                                                  <span
                                                    style={{ color: "#576D90" }}
                                                  >
                                                    .
                                                  </span>
                                                ) : (
                                                  ""
                                                )}
                                                {activity.lastscore !== null &&
                                                  activity.activitytype !== "G"
                                                  ? `${activity.lastscore}%`
                                                  : ""}
                                              </p>
                                            </div>
                                          </div>
                                        )
                                      )}

                                      {(WlpData?.extra_activities ?? [])
                                        .length > 0 && (
                                          <div
                                            className="wlp_list_item_row wlp_list_added_activities"
                                            id="divExtraWLPActivity"
                                          >
                                            <span id="spnExtraActivites">
                                              Extra activities (max 5)
                                            </span>
                                            {(WlpData?.extra_activities ?? [])
                                              .length === 5 ? (
                                              <span
                                                className="list_smileicon"
                                                id="spnLogo"
                                                style={{
                                                  display: "block",
                                                  color: "#576D90",
                                                  paddingRight: "60px",
                                                }}
                                              >
                                                .
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                            <span id="wlpText"></span>
                                            {(
                                              WlpData?.extra_activities ?? []
                                            ).map((extra_activity, index) => (
                                              <div
                                                className="wlp_list_item_row"
                                                key={index}
                                                style={{
                                                  backgroundColor: "#576D90",
                                                }}
                                              >
                                                <div className="wlp_list_current_activity_box wlp_list_current_activity_arrow"></div>
                                                <div
                                                  className={`wlp_list_current_activity_icon ${extra_activity.activitytype?.toLowerCase() === "t"
                                                    ? "wlp_list_current_activity_icon_test"
                                                    : extra_activity.activitytype?.toLowerCase() === "g"
                                                      ? "wlp_list_current_activity_icon_game"
                                                      : "wlp_list_current_activity_icon_lesson"
                                                    }`}
                                                ></div>
                                                <div className="wlp_list_current_activity_name">
                                                  <p>
                                                    {
                                                      extra_activity.ChildShortDesc
                                                    }
                                                  </p>
                                                </div>
                                                <div className="wlp_list_current_activity_percentage">
                                                  <p
                                                    style={{
                                                      paddingTop:
                                                        "3px !important",
                                                    }}
                                                  >
                                                    {extra_activity.lastscore !==
                                                      null
                                                      ? `${extra_activity.lastscore}%`
                                                      : ""}
                                                  </p>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        )}
                                    </div>
                                    <div
                                      className="add_activity_container"
                                      id="divDoAgainActivityBtn"
                                      style={{
                                        display:
                                          parseInt(WlpProgress) === 100
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      <div
                                        id="wlp_DoAgain_btn"
                                        className="add_activity_btn"
                                      >
                                        <a
                                          id="lnkDoAgain"
                                          onClick={handleDoAgainClick}
                                        >
                                          Do again (optional)
                                        </a>
                                      </div>
                                      {WlpData?.extra_activities &&
                                        WlpData.extra_activities.length < 5 && (
                                          <div
                                            id="wlp_add_activity_btn"
                                            className="add_activity_btn"
                                          >
                                            <a
                                              id="lnkDoMore"
                                              href="/STUDENT/MSR/DoMore"
                                            >
                                              Do more (optional)
                                            </a>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )}
                            
                            <div id="divWLPSection">
                              {shouldShowWlpGenerating && (
                                <div id="divgenerate_wlp_div_english">
                                  <div
                                    id="divWLPReschedulingTitle"
                                    className="subject_container_title"
                                  >
                                    <p>New Week's Activities</p>
                                  </div>
                                  <div
                                    id="divWLPReschedulingImage"
                                    className="subject_WLP"
                                  >
                                    {reportData?.subject === "Mathematics" ? (
                                      <img
                                        src="https://www.elearnoncloud.com/STUDENT/MSR/Image/new_msr_wlp_generating_maths.gif"
                                        alt="Generating activities for Mathematics"
                                      />
                                    ) : reportData?.subject === "Science" ? (
                                      <img
                                        src="https://www.elearnoncloud.com/STUDENT/MSR/Image/new_msr_wlp_generating_english.gif"
                                        alt="Generating activities for Science"
                                      />
                                    ) : (
                                      <img
                                        src="https://www.elearnoncloud.com/STUDENT/MSR/Image/new_msr_wlp_generating_english.gif"
                                        alt="Generating activities for English"
                                      />
                                    )}
                                  </div>
                                  <div
                                    id="divWLPStatusText"
                                    className="subject_container_text"
                                  >
                                    <p>
                                      Your new week’s activities are being
                                      generated
                                    </p>
                                  </div>
                                </div>
                              )}
                              <div className="subject_middle_gap"></div>
                              <div className="divExploreActivities">
                                <div
                                  className="double_btn_container"
                                  style={{ marginTop: "0" }}
                                >
                                  <div
                                    className="activity_btnT double_btnT"
                                    onClick={handleSkilledBUildGames}
                                  >
                                    <span
                                      id="math_wlp_icon"
                                      className="activity_iconT activity_icon_wizgames"
                                    ></span>
                                    <a id="lnkViewAllGames">
                                      Skill Building Games
                                    </a>
                                  </div>
                                  <div
                                    className="activity_btnT double_btnT"
                                    onClick={handleExploreActivity}
                                  >
                                    <span className="activity_iconT activity_icon_search"></span>
                                    <a id="linkbtnExploreActivities">
                                      Explore Activities
                                    </a>
                                  </div>
                                </div>
                              </div>
                              {/* <hr className="subject_inner_hr" /> */}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {trophyVisible && (
                      <div id="trophy_club_rank_up_overlay">
                        <div className="trophy_club_rank_up_container_title">
                          <p>
                            CONGRATULATIONS. WELCOME TO CLUB{" "}
                            <span className="bonus_points_text" style={{fontSize:'20px', color:'#fff'}}>{trophy}</span>!
                          </p>
                        </div>
                        <div id="WLP_completed_english_reward_div1">
                          <div id="trophy_rays1"></div>
                          <div
                            id="trophy_club_rank_up_trophy"
                            style={{
                              backgroundImage: `url(${getTrophyImage(
                                rewardPoints
                              )})`,
                              backgroundSize: "contain",
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center",
                            }}
                          ></div>
                          <div id="trophy_club_rank_up_shadow"></div>
                          <div id="dot_container1">
                            <div className="dot" id="dot01"></div>
                            <div className="dot" id="dot02"></div>
                            <div className="dot" id="dot03"></div>
                            <div className="dot" id="dot04"></div>
                            <div className="dot" id="dot05"></div>
                            <div className="dot" id="dot06"></div>
                            <div className="dot" id="dot07"></div>
                            <div className="dot" id="dot08"></div>
                          </div>
                          <div className="subject_container_text">
                            <p>
                              You will now receive <br />
                              <span
                                id="spnpoints"
                                className="bonus_points_text"
                              >
                                {rewardPoints}
                              </span>{" "}
                              <br />
                              bonus points for each trophy you earn.
                            </p>
                          </div>
                          <div className="trophy_club_rank_up_button_box">
                            <div
                              id="trophy_club_rank_up_ok_btn"
                              className="general_btn trophy_club_rank_up_btn trophy_club_rank_up_ok_btn_english"
                              onClick={handleTrophyOkClick}
                            >
                              <a>OK</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <Loading />
              )}
            </>
          )}
        </SubHeader>
      </div>
    </form>
  );
};

export default StudyRoom;